"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _product = require("@/api/product");
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import keyword from '@/components/keyword.vue'; // 假设keyword组件路径
var _default = exports.default = {
  name: 'StoreAttr',
  // components: { keyword },
  data: function data() {
    // 表单验证规则
    var validatePercentage = function validatePercentage(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入' + rule.message));
      } else if (isNaN(value) || value < 0 || value > 100) {
        callback(new Error('请输入0-100之间的数字'));
      } else {
        callback();
      }
    };
    var validateRequired = function validateRequired(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入' + rule.message));
      } else {
        callback();
      }
    };
    return {
      dialogType: 1,
      // 打开弹窗的方式，1为处理单个，2为批量处理
      propsPlant2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      propsPlant: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      labelarr: [],
      // 表单数据
      formValidate: {
        categoryId: '',
        //平台分类
        brandName: '',
        // 品牌名称
        // tempId: '', // 运费模板
        ratio: '',
        // 商品让利比例
        ratioM: '',
        // 加价比例
        intro: '',
        // 商品简介
        keyword: '',
        // 商品关键字
        unitName: '' // 单位
      },
      // 品牌相关
      brandList: [],
      brandLoading: false,
      // 表单验证规则
      addFormRules: {
        // tempId: [{ required: true, message: '请选择运费模板', trigger: 'change' }],
        categoryId: [{
          required: true,
          message: '请选择平台分类',
          trigger: 'change'
        }],
        brandName: [{
          required: true,
          message: '请选择品牌',
          trigger: 'change'
        }],
        ratio: [{
          required: true,
          message: '请输入商品让利比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === undefined || value === null) {
              callback(new Error('请输入商品让利比例'));
            } else if (!/^\d+$/.test(value)) {
              callback(new Error('让利比例必须为整数'));
            } else if (parseInt(value, 10) < 3 || parseInt(value, 10) > 30) {
              callback(new Error('让利比例范围为3%~30%的整数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        ratioM: [{
          required: true,
          message: '请输入加价比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === undefined || value === null) {
              callback(new Error('请输入加价比例'));
            } else if (!/^\d+$/.test(value)) {
              callback(new Error('加价比例必须为正整数'));
            } else if (parseInt(value, 10) < 0 || parseInt(value, 10) > 100) {
              callback(new Error('让利比例范围为0%~100%的整数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入商品简介',
          trigger: 'blur'
        }, {
          max: 100,
          message: '简介不能超过 100 个字符',
          trigger: 'blur'
        }],
        keyword: [{
          required: true,
          message: '请输入商品关键字',
          trigger: 'change'
        }],
        unitName: [{
          required: true,
          validator: validateRequired,
          message: '单位',
          trigger: 'blur'
        }, {
          max: 20,
          message: '单位不能超过 20 个字符',
          trigger: 'blur'
        }]
      },
      // 弹窗相关
      dialogVisible: false,
      currentProduct: null,
      // 原有数据
      typeList: [],
      formDynamic: {
        ruleName: '',
        ruleValue: []
      },
      tableFrom: {
        name: '',
        pageNum: 1,
        categoryId3s: '',
        pageSize: this.$constants.page.limit[0]
      },
      keyword: '',
      tableData: {
        data: [],
        loading: false,
        total: 0
      },
      listLoading: false,
      selectionList: [],
      multipleSelectionAll: [],
      multipleSelection: [],
      //当前勾选的行，用于批量处理
      idKey: 'proId',
      nextPageFlag: false,
      keyNum: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['shippingTemplates', 'merPlatProductClassify', 'Categorys', 'categoryChainList'])), {}, {
    filteredCategorys: function filteredCategorys() {
      if (!this.categoryChainList || this.categoryChainList.length === 0) return [];

      // 过滤分类数据
      return this.categoryChainList.map(function (category) {
        // 检查一级分类是否有子分类
        if (!category.childList || category.childList.length === 0) {
          return null; // 过滤掉没有二级分类的一级分类
        }

        // 过滤二级分类，只保留有三级分类的
        var filteredChildren = category.childList.filter(function (subCategory) {
          return subCategory.childList && subCategory.childList.length > 0;
        });

        // 如果还有剩余的二级分类，则返回该一级分类及其过滤后的二级分类
        if (filteredChildren.length > 0) {
          return _objectSpread(_objectSpread({}, category), {}, {
            childList: filteredChildren
          });
        }

        // 如果没有有效的二级分类，则不返回该一级分类
        return null;
      }).filter(function (category) {
        return category !== null;
      }); // 过滤掉不符合条件的一级分类
    }
  }),
  mounted: function mounted() {
    // this.getTypeList()
    if (!localStorage.getItem('Categorys')) this.$store.dispatch('product/getCategorysApi');
    if (!localStorage.getItem('categoryChainList')) this.$store.dispatch('product/getCategoryChainListApi');
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
    if ((0, _permission.checkPermi)(['merchant:product:rule:page:list'])) this.getList();
    if (!localStorage.getItem('shippingTemplates')) {
      this.$store.dispatch('product/getShippingTemplates');
    }
  },
  methods: {
    ceshi: function ceshi(val) {
      this.$nextTick(function () {
        if (val && val.length > 0) {
          console.log('选中的分类:', val);
        } else {}
      });
    },
    // 品牌相关方法
    onChangeCategory: function onChangeCategory() {
      this.formValidate.brandName = '';
      this.brandList = [];
      if (this.formValidate.categoryId) {
        this.getbrandList();
      }
    },
    // 获取品牌列表
    getbrandList: function getbrandList() {
      var _this2 = this;
      this.brandLoading = true;
      (0, _product.brandListApi)({
        cid: this.formValidate.categoryId,
        page: 1,
        limit: 999
      }).then(function (res) {
        _this2.brandList = res.list || [];
        _this2.brandList.push({
          name: '其他',
          id: 0
        });
        _this2.brandLoading = false;
      }).catch(function () {
        _this2.brandList = [];
        _this2.brandList.push({
          name: '其他',
          id: 0
        });
        _this2.brandLoading = false;
      });
    },
    // 监听勾选变化，实时更新选中数据
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection, 'this.multipleSelection');
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
      this.formValidate.keyword = attr.join(','); // 将关键字数组转为字符串
    },
    checkPermi: _permission.checkPermi,
    handleSearchList: function handleSearchList() {
      this.tableFrom.pageNum = 1;
      this.tableFrom.name = this.keyword;
      this.getList();
    },
    add: function add() {
      var _this = this;
      this.$modalAttr(Object.assign({}, this.formDynamic), function () {
        _this.getList();
      }, this.keyNum += 1);
    },
    // // 获取分类列表
    getTypeList: function getTypeList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _product.getTypeListApi)().then(function (res) {
        _this3.typeList = res;
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    // 获取商品列表
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      if (this.tableFrom.name == '') {
        delete this.tableFrom.name;
      }
      if (this.tableFrom.categoryId3s == '') {
        delete this.tableFrom.categoryId3s;
      }
      (0, _product.storeProductList)(this.tableFrom).then(function (res) {
        var list = res.rows;
        _this4.tableData.data = list;
        _this4.tableData.total = res.total;
        // 处理图片列表
        if (list && list.length > 0) {
          list.forEach(function (item, index) {
            try {
              var imgList = JSON.parse(item.detailImgList) || [];
              _this4.tableData.data[index].bigImg = imgList[0] || '';
            } catch (error) {
              console.error('解析图片列表失败:', error);
              _this4.tableData.data[index].bigImg = '';
            }
          });
        }

        // 处理规格值
        list.forEach(function (item) {
          try {
            item.ruleValue = typeof item.ruleValue === 'string' ? JSON.parse(item.ruleValue) : item.ruleValue || [];
          } catch (error) {
            console.error('解析规格值失败:', error);
            item.ruleValue = [];
          }
        });
        _this4.listLoading = false;
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.pageNum = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.pageSize = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this5 = this;
      this.$modalSure().then(function () {
        (0, _product.attrDeleteApi)(id).then(function () {
          _this5.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this5.tableData.data.length, _this5.tableFrom);
          _this5.getList();
        });
      }).catch(function () {});
    },
    handleDeleteAll: function handleDeleteAll() {
      var _this6 = this;
      if (!this.multipleSelectionAll.length) return this.$message.warning('请选择商品规格');
      var data = [];
      this.multipleSelectionAll.map(function (item) {
        data.push(item.id);
      });
      this.ids = data.join(',');
      this.$modalSure().then(function () {
        (0, _product.attrDeleteApi)(_this6.ids).then(function () {
          _this6.$message.success('删除成功');
          _this6.getList();
        });
      }).catch(function () {});
    },
    // 打开添加到我的商品弹窗
    onEdit: function onEdit(row) {
      var _this7 = this;
      if (!row && this.multipleSelection.length < 1) {
        this.$message.error('请先选择要批量处理的商品');
        return;
      }
      if (row) {
        this.$refs.table.clearSelection();
        // this.multipleSelection = []
      }
      if (this.multipleSelection.length == 0) {
        this.dialogType = 1;
        this.currentProduct = row;
      } else {
        this.dialogType = 2;
      }
      // 保存当前选中的商品

      // 重置表单
      this.$nextTick(function () {
        if (_this7.$refs.addForm) {
          _this7.$refs.addForm.resetFields();
        }
      });

      // 重置表单数据
      this.formValidate = {
        categoryId: '',
        brandName: '',
        // tempId: '',
        ratio: '',
        ratioM: '',
        intro: '',
        keyword: '',
        unitName: ''
      };
      this.labelarr = [];
      this.brandList = [];

      // 显示弹窗
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      this.dialogVisible = false;
      // 重置表单
      if (this.$refs.addForm) {
        this.$refs.addForm.resetFields();
      }
      this.labelarr = [];
      this.brandList = [];
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this8 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          var ids = [];
          var submitData = {};
          if (_this8.dialogType == 1) {
            //单个商品处理
            ids = _this8.currentProduct.proId;
            console.log('单个商品ID:', ids, '当前商品:', _this8.currentProduct);
            // 转换比例为小数（除以100）
            submitData = _objectSpread(_objectSpread({}, _this8.formValidate), {}, {
              id: ids,
              productName: _this8.currentProduct.name,
              keyword: _this8.labelarr.join(','),
              // 转换为小数形式提交
              ratio: parseFloat(_this8.formValidate.ratio) / 100,
              ratioM: parseFloat(_this8.formValidate.ratioM) / 100
            });
            console.log('提交数据:', submitData);
            // 调用添加接口
            (0, _product.addToMyProductApi)(submitData).then(function (res) {
              _this8.$message.success('添加成功');
              _this8.dialogVisible = false;
              _this8.labelarr = [];
              _this8.currentProduct = null;
              _this8.getList();
            }).catch(function (err) {
              _this8.$message.error(err.msg || '添加失败');
            });
          } else if (_this8.dialogType == 2) {
            //批量处理
            _this8.multipleSelection.forEach(function (e) {
              ids.push(e.proId);
            });
            console.log('批量商品ID:', ids);
            submitData = {
              id: ids,
              unitName: _this8.formValidate.unitName,
              ratio: parseFloat(_this8.formValidate.ratio) / 100,
              ratioM: parseFloat(_this8.formValidate.ratioM) / 100,
              categoryId: _this8.formValidate.categoryId,
              // tempId: this.formValidate.tempId,
              brandName: _this8.formValidate.brandName
            };
            console.log('批量提交数据:', submitData);
            // 调用添加接口
            (0, _product.batchAddToMyProductMoreApi)(submitData).then(function (res) {
              _this8.$message.success('添加成功');
              _this8.dialogVisible = false;
              _this8.labelarr = [];
              _this8.currentProduct = null;
              _this8.$refs.table.clearSelection();
              _this8.getList();
            }).catch(function (err) {
              _this8.$message.error(err.msg || '添加失败');
            });
          }
        } else {
          _this8.$message.warning('请完善表单信息');
          return false;
        }
      });
    }
  }
};